
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 .063C8.367.063.562 7.938.562 17.5c0 9.633 7.805 17.438 17.438 17.438 9.563 0 17.438-7.805 17.438-17.438C35.438 7.937 27.561.062 18 .062zm0 32.624c-8.367 0-15.188-6.75-15.188-15.187C2.813 9.203 9.563 2.312 18 2.312c8.297 0 15.188 6.82 15.188 15.188 0 8.367-6.82 15.188-15.188 15.188zm9.914-19.265c.352-.352.352-.914 0-1.195l-.562-.633c-.352-.352-.915-.352-1.196 0l-11.531 11.39-4.852-4.851c-.28-.352-.843-.352-1.195 0l-.562.562c-.352.352-.352.844 0 1.196l6.046 6.117c.282.281.844.281 1.196 0l12.656-12.586z","fill":"currentColor"}})])
          )
        }
      }
    